/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.listing.details.rpc.MarketplaceListingDetailsRpc
 */
import { createRpcClientV2 } from 'rpc-client-utils';
import { registerQuery } from 'data-fetching-client/next';
import http from 'hub-http/clients/apiClient';
import * as References from './MarketplaceListingDetailsRpc-app';
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.listing.details.rpc.MarketplaceListingDetailsRpc#getListingDetailsV1
 */
export const GET_LISTING_DETAILS_V1_QUERY_FIELD_NAME = 'com_hubspot_marketplace_listing_details_rpc_MarketplaceListingDetailsRpc_getListingDetailsV1';
export const GET_LISTING_DETAILS_V1_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_LISTING_DETAILS_V1_QUERY_FIELD_NAME,
  args: ['slug', 'language'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.getListingDetailsV1Rpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.listing.details.rpc.MarketplaceListingDetailsRpc#getListingDetailsV2
 */
export const GET_LISTING_DETAILS_V2_QUERY_FIELD_NAME = 'com_hubspot_marketplace_listing_details_rpc_MarketplaceListingDetailsRpc_getListingDetailsV2';
export const GET_LISTING_DETAILS_V2_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_LISTING_DETAILS_V2_QUERY_FIELD_NAME,
  args: ['slug', 'language'],
  fetcher(request, ctx) {
    var _ctx$customClient2;
    return ((_ctx$customClient2 = ctx.customClient) !== null && _ctx$customClient2 !== void 0 ? _ctx$customClient2 : chirpClient).call(References.getListingDetailsV2Rpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.listing.details.rpc.MarketplaceListingDetailsRpc#getListingDetailsV3
 */
export const GET_LISTING_DETAILS_V3_QUERY_FIELD_NAME = 'com_hubspot_marketplace_listing_details_rpc_MarketplaceListingDetailsRpc_getListingDetailsV3';
export const GET_LISTING_DETAILS_V3_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_LISTING_DETAILS_V3_QUERY_FIELD_NAME,
  args: ['slug', 'language'],
  fetcher(request, ctx) {
    var _ctx$customClient3;
    return ((_ctx$customClient3 = ctx.customClient) !== null && _ctx$customClient3 !== void 0 ? _ctx$customClient3 : chirpClient).call(References.getListingDetailsV3Rpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.listing.details.rpc.MarketplaceListingDetailsRpc#isStandardizedInstall
 */
export const IS_STANDARDIZED_INSTALL_QUERY_FIELD_NAME = 'com_hubspot_marketplace_listing_details_rpc_MarketplaceListingDetailsRpc_isStandardizedInstall';
export const IS_STANDARDIZED_INSTALL_QUERY = /* #__PURE__ */registerQuery({
  fieldName: IS_STANDARDIZED_INSTALL_QUERY_FIELD_NAME,
  args: ['listingId'],
  fetcher(request, ctx) {
    var _ctx$customClient4;
    return ((_ctx$customClient4 = ctx.customClient) !== null && _ctx$customClient4 !== void 0 ? _ctx$customClient4 : chirpClient).call(References.isStandardizedInstallRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});